import { GET_INVOICES } from "./graphql/get-invoices"
import { CREATE_MINISTRATION, UPDATE_MINISTRATION } from "./graphql"
import { graphqlApolloClient } from "../graphql-apollo-client"

export const ministrationService = () => {
  const getInvoices = async ({ submissionId }) => {
    const { data } = await graphqlApolloClient.query({
      query: GET_INVOICES,
      fetchPolicy: "network-only",
      variables: {
        id: submissionId
      }
    })

    return data?.Submission
  }

  const createMinistration = async ({
    ministrationPeriodId,
    totalSaved,
    paymentDate,
    paymentAmount,
    totalSupplied,
    totalNoSupplied,
    paymentBreakdown,
    suppliedBreakdown,
    savedBreakdown,
    ministrationDocuments // {id, url, name, type}[]
  }) => {
    const mutationData = {
      totalSaved,
      paymentDate,
      paymentAmount,
      totalSupplied,
      totalNoSupplied,
      paymentBreakdown,
      suppliedBreakdown,
      savedBreakdown,
      ministrationDocuments
    }
    const result = await graphqlApolloClient.mutate({
      mutation: CREATE_MINISTRATION,
      variables: {
        createMinistrationData: mutationData,
        ministrationPeriodId
      }
    })

    return result.data?.createMinistration
  }

  const updateMinistration = async ({
    totalSaved,
    paymentDate,
    paymentAmount,
    paymentBreakdown,
    suppliedBreakdown,
    savedBreakdown,
    totalSupplied,
    ministrationId,
    totalNoSupplied,
    ministrationDocuments, // {id, url, name, type}[]
    ministrationPaymentDocuments
  }) => {
    const mutationData = {
      totalSaved,
      paymentDate,
      paymentAmount,
      paymentBreakdown,
      suppliedBreakdown,
      savedBreakdown,
      totalSupplied,
      totalNoSupplied,
      ministrationDocuments,
      ministrationPaymentDocuments
    }
    const result = await graphqlApolloClient.mutate({
      mutation: UPDATE_MINISTRATION,
      variables: {
        ministrationId,
        ministrationData: mutationData
      }
    })

    return result.data?.UpdateMinistration
  }

  return {
    getInvoices,
    updateMinistration,
    createMinistration
  }
}
